import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { connectionRows, type StageRow, StagesByWorkflowDocument } from "#app/lib/data";
import { compareStages } from "#app/lib/stage-order";

export function useWorkflowStages(workflowId: string | undefined): {
  stages: StageRow[];
  loading: boolean;
} {
  const variables = useMemo(
    () => ({ workflowId: workflowId! }),
    [workflowId],
  );
  const { data, loading } = useQuery(StagesByWorkflowDocument, {
    variables,
    skip: !workflowId,
  });
  const stages = useMemo(() => connectionRows(data?.stages).sort(compareStages), [data]);
  return { stages, loading };
}
